<template>
  <div>
    <a-card class="card cursor-pointer" @click.native="visible= true">
      <tk-flex middle between>
        <tk-flex middle>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="30"
            height="30"
            viewBox="0 0 30 30"
          >
            <defs>
              <linearGradient
                x1="0.5"
                y1="0"
                x2="0.5"
                y2="1"
                id="master_svg0_295_116130"
              >
                <stop offset="0%" stop-color="#C195EF" stop-opacity="1" />
                <stop offset="100%" stop-color="#9F64E0" stop-opacity="1" />
              </linearGradient>
              <clipPath id="master_svg1_295_035959">
                <rect x="6" y="6" width="18" height="18" rx="0" />
              </clipPath>
            </defs>
            <g>
              <g>
                <ellipse
                  cx="15"
                  cy="15"
                  rx="15"
                  ry="15"
                  fill="url(#master_svg0_295_116130)"
                  fill-opacity="1"
                />
              </g>
              <g clip-path="url(#master_svg1_295_035959)">
                <g>
                  <path
                    d="M12.659912109375,14.09998291015625C12.675466009375,15.43554291015625,13.754352109375,16.514432910156252,15.089912109375,16.52998291015625C15.719912109375,16.52998291015625,16.349912109375,16.25998291015625,16.799912109375,15.80998291015625C17.249912109375,15.35998291015625,17.519912109375,14.81998291015625,17.519912109375,14.09998291015625C17.504362109375002,12.76442291015625,16.425472109375,11.68553651015625,15.089912109375,11.66998291015625C14.459912109375,11.66998291015625,13.829912109375,11.93998291015625,13.379912109375,12.38998291015625C12.929912109375,12.92998291015625,12.659912109375,13.46998291015625,12.659912109375,14.09998291015625Z"
                    fill="#FFFFFF"
                    fill-opacity="1"
                  />
                </g>
                <g>
                  <path
                    d="M21.390048828125,17.7900244140625C22.020048828125,16.710024414062502,22.380048828125,15.4500244140625,22.380048828125,14.1900244140625C22.380048828125,12.840024414062501,22.020048828125,11.6700244140625,21.390048828125,10.5900244140625C20.760048828125,9.5100244140625,19.860048828125002,8.6100244140625,18.690048828125,7.9800244140625C17.610048828125002,7.2600244140625,16.440048828125,6.9000244140625,15.090048828125,6.9000244140625C13.830048828125001,6.9000244140625,12.570048828125,7.2600244140625,11.400048828125,7.8900244140625C10.320048828125,8.520024414062501,9.420048828125001,9.4200244140625,8.790048828125,10.5000244140625C8.160048828125,11.5800244140625,7.800048828125,12.840024414062501,7.800048828125,14.1000244140625C7.800048828125,15.4500244140625,8.160048828125,16.6200244140625,8.790048828125,17.7000244140625C9.330048828125,18.6000244140625,10.050048828125,19.410024414062498,10.860048828125,19.9500244140625C9.780048828125,20.4000244140625,9.150048828125,20.8500244140625,9.150048828125,21.3000244140625C9.150048828125,22.2900244140625,11.850048828125,23.1000244140625,15.090048828125,23.1000244140625C18.330048828125,23.1000244140625,21.030048828125,22.2900244140625,21.030048828125,21.3000244140625C21.030048828125,20.8500244140625,20.400048828125,20.4000244140625,19.320048828125,20.0400244140625C20.220048828125,19.410024414062498,20.850048828125,18.6900244140625,21.390048828125,17.7900244140625ZM12.300048828125,11.4000244140625C13.110048828124999,10.5900244140625,14.010048828125,10.2300244140625,15.090048828125,10.2300244140625C16.170048828124997,10.2300244140625,17.070048828125,10.5900244140625,17.880048828125,11.4000244140625C18.690048828125,12.120024414062499,19.050048828125,13.1100244140625,19.050048828125,14.1900244140625C19.050048828125,15.2700244140625,18.690048828125,16.1700244140625,17.880048828125,16.9800244140625C17.070048828125,17.7000244140625,16.170048828124997,18.1500244140625,15.090048828125,18.1500244140625C14.010048828125,18.1500244140625,13.110048828124999,17.7900244140625,12.300048828125,16.9800244140625C11.580048828125,16.1700244140625,11.130048828125,15.1800244140625,11.130048828125,14.1000244140625C11.130048828125,13.020024414062501,11.580048828125,12.120024414062499,12.300048828125,11.4000244140625Z"
                    fill="#FFFFFF"
                    fill-opacity="1"
                  />
                </g>
              </g>
            </g>
          </svg>
          <div class="p-l-12 font-15 font-bold">{{ equipment.name }}</div>
        </tk-flex>
      </tk-flex>
      <a-row class="p-t-20 font-14 color-gray-card" :gutter="[34, 20]">
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">状态</div>
          <tk-flex middle :class='equipment.status == "normal" ? "nomal" : "error"'>
            <div class="status-icon m-r-5"></div>
            <div>{{ equipment.status == "normal" ? "正常" : "异常" }}</div>
          </tk-flex>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">异常次数</div>
          <div>{{ equipment.errorNum }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">最新异常时间</div>
          <div>{{ formatTimeShow(equipment.errorTime) }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">所属粮库</div>
          <div>{{ equipment.graindepot.name }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">所属粮仓</div>
          <div>{{ equipment.grainstore.name }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">IP</div>
          <div>{{ equipment.IP }}</div>
        </a-col>
      </a-row>
    </a-card>
    <a-modal
    :maskClosable="false"
      title="异常明细"
      :visible="visible"
      destroyOnClose
      :width="522"
      @ok="visible = false"
      @cancel="visible = false"
    >
      <ErrorCard :id="equipment.objectId"/>
    </a-modal>
  </div>
</template>
<script>
import { formatTimeShow } from '../../utils/format.js'
import ErrorCard from './errorCard'
export default {
  props: {
    equipment: {
      type: Object,
      required: true
    }
  },
  components: {
    ErrorCard
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    formatTimeShow (time) {
      const str = formatTimeShow(time)
      return str
    }
  }
}
</script>

<style scoped lang="scss">
.card-tag {
  color: #94979c;
  background: #dde0e5;
  font-size: 12px;
  margin-left: 5px;
  border-radius: 3px;
  padding: 0px 3px;
}
.nomal {
  .status-icon{
    background-color: #2FBF79;
  }
  div{
    color: #2FBF79;
  }
}
.error {
  .status-icon{
    background-color: #FE2A58;
  }
  div{
    color: #FE2A58;
  }
}
.status-icon{
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
</style>
